import {
  EXPIRE_IN,
  LINK_TRACK_PROTOCOLS,
  RESP_ERROR,
  RESP_SUCCESS,
  RESP_WARNING
} from 'Pages/MessageCreate/const'
import {
  deleteMessage,
  getPresignedUrlPut,
  setSelfImport,
  uploadFile
} from '../actions/actions'

import { pageState } from 'Pages/MessageCreate/recoil/state/page'
import { logAppError } from 'Helpers/logger'
import {
  UPLOADER_VARIANT_DEFAULT,
  UPLOADER_VARIANT_UPLOADED
} from 'mailup-web-components'
import getIntl from 'Helpers/intl'
import { modalDelete } from '../state/modals'

export const uploadFileCallback = ({ set, snapshot }) => async () => {
  const { file } = await snapshot.getPromise(pageState)
  try {
    const url = await getPresignedUrlPut(EXPIRE_IN)
    const upload = await uploadFile(url, file)

    if (upload && upload.status === 200) {
      set(pageState, prev => ({
        ...prev,
        variant: UPLOADER_VARIANT_UPLOADED,
        url: url.Identifier
      }))
    } else {
      set(pageState, prev => ({
        ...prev,
        variant: UPLOADER_VARIANT_DEFAULT,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'MessageCreate',
      Method: 'uploadFileCallback',
      Message: 'Errore durante il caricamento di un file',
      Data: JSON.stringify(file)
    })
    set(pageState, prev => ({
      ...prev,
      variant: UPLOADER_VARIANT_DEFAULT,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const saveMessageCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))

  let success = false
  const {
    url: urlOrIdentify,
    subject: Subject,
    notes: Notes,
    pageType,
    file,
    extension
  } = await snapshot.getPromise(pageState)
  try {
    const message = {
      Embed: false,
      UseDynamicField: true,
      Fields: [],
      Tags: [],
      Source: urlOrIdentify, // url contain fileUrl or httpUrl extension
      SourceType: file ? extension : 'url',
      IsConfirmation: false,
      Notes,
      Subject,
      PreHeader: '',
      TrackingInfo: {
        Enabled: true,
        Protocols: LINK_TRACK_PROTOCOLS.filter(e => e.selected).map(
          e => e.value
        )
      }
    }

    const response = await setSelfImport(message)

    if ('IdMessage' in response) {
      const warning =
        response.Status.toLowerCase() === RESP_WARNING.toLowerCase()
      const boxError = response.Status.toLowerCase() === RESP_ERROR.toLowerCase()
      success = response.Status.toLowerCase() === RESP_SUCCESS.toLowerCase()
      set(pageState, prev => ({
        ...prev,
        response,
        warning,
        boxError,
        success,
        isDirty: false // l'utente pu� lasciare la pagina senza domande
      }))
    } else {
      set(pageState, prev => ({
        ...prev,
        variant: UPLOADER_VARIANT_DEFAULT,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'MessageCreate',
      Method: 'saveMessageCallback',
      Message: `Errore durante il salvataggio di un messaggio tramite ${pageType}`,
      Data: JSON.stringify(urlOrIdentify)
    })
    set(pageState, prev => ({
      ...prev,
      variant: UPLOADER_VARIANT_DEFAULT,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({
    ...prev,
    loading: success // se success deve rimanere il loader finch� non fa il redirect
  }))
}

export const deleteMessageCallback = ({ set, snapshot }) => async idMessage => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))

  try {
    const res = await deleteMessage(idMessage) // {"Result":true}
    if (res.Result) {
      await resetStateWithoutPageType(set)
    } else {
      set(pageState, prev => ({
        ...prev,
        variant: UPLOADER_VARIANT_DEFAULT,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'MessageCreate',
      Method: 'deleteMessageCallback',
      Message: `Errore durante la cancellazione del messaggio, id: ${idMessage}`,
      Data: JSON.stringify(idMessage)
    })
    set(pageState, prev => ({
      ...prev,
      variant: UPLOADER_VARIANT_DEFAULT,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const resetStateCallback = ({ set }) => async idMessage => {
  resetStateWithoutPageType(set)
}

async function resetStateWithoutPageType (set) {
  set(pageState, prev => ({
    ...prev,
    isDirty: false,
    loaded: false,
    loading: false,
    error: false,
    severity: 'danger',
    warning: false,
    warningAction: undefined, // setta dirty a false per lasciare la pagina
    success: false,
    pageTitle: '',
    subject: '',
    isSubjectDirty: false,
    notes: '',
    url: '', // httpUrl or fileUrl
    isUrlDirty: false,
    file: undefined,
    variant: UPLOADER_VARIANT_DEFAULT,
    extension: '',
    response: undefined
  }))
  // chiude la modale
  set(modalDelete, prev => ({
    ...prev,
    show: false
  }))
}
